// HARD-CODED values for the vehicle record (Vehicles menu).
//
// Everything the mockup's vehicle page shows that Klargo does not (yet) store in its database is
// kept here, in one place, copied from Klargo-Reference's demo vehicle (Volvo V60 DXH 421). The
// record uses these ONLY where the deal's car record has no value; whatever the database holds
// (registration number, name, model year, fuel, gearbox, drive, inspection dates, mileage, seller
// name, deal dates) always wins. Replace an entry here with real data once a table holds it.
export const VEHICLE_RECORD_DEMO = {
  // Insurance: no insurance table exists. (Mockup: If, halvförsäkring, via Zmarta.)
  insurance: {
    provider: 'If',
    coverage: { sv: 'Halvförsäkring', en: 'Partial cover' },
    monthlyPremiumSek: 429,
    annualPremiumSek: 5148,
    deductibleSek: 1500,
    startDate: '2024-03-13T12:00:00',
    maskedPolicyNumber: 'IF-••••4712',
    broker: 'Zmarta',
    documentDate: '2024-03-13T12:00:00',
  },
  // Inspection: the result and, when the registry gave no valid-until date, the whole deadline.
  inspection: {
    approved: true,
    // used only when the car record has no "valid until" date
    fallbackDaysLeft: 72,
    fallbackDeadline: '2026-09-29T12:00:00',
    fallbackLastInspected: '2025-09-02T12:00:00',
    fallbackTodayLabelDate: '2026-07-19T12:00:00',
    fallbackTodayPosition: 0.82, // where "Idag" sits on the line
    fallbackMileageKm: 89420,
    fallbackDocumentDate: '2025-09-02T12:00:00',
  },
  // Technical facts the car record does not hold.
  facts: {
    vin: 'YV1ZW1MK5M2456321',
    engine: { sv: '2,0 l, 197 hk', en: '2.0 l, 197 hp' },
    body: { sv: 'Kombi', en: 'Estate' },
    doors: '5',
    seats: '5',
    colour: 'Onyx Black',
  },
};
